import styled from 'styled-components';

export const StyledLoginPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
`;
